/**
 * 셸 실행 설정 — Vite 환경 변수에서 읽는다(빌드 시 고정). 런타임 설정(RuntimeConfig)은 S3 에서 API 로 받는다.
 */
export interface ShellConfig {
  apiBase: string;
  fake: boolean;
  campusOrigins: readonly string[];
  campusUrl: string | null;
  /**
   * Bench 웹 출처(VITE_BENCH_URL 의 origin) — 'Bench 에서 고치기' 가 여는 editorUrl 과 돌아올 때 받는 postMessage 를 이 출처로만 받는다.
   * 없으면 Bench 로 가는 버튼을 그리지 않는다.
   */
  benchOrigin: string | null;
}

/** http(s) 절대 주소의 origin — 형식 밖이면 null */
export function originOf(url: string | null | undefined): string | null {
  if (!url) return null;
  try {
    const u = new URL(url);
    return u.protocol === "http:" || u.protocol === "https:" ? u.origin : null;
  } catch {
    return null;
  }
}

const trimSlash = (s: string) => s.replace(/\/+$/, "");

export function readConfig(env: ImportMetaEnv = import.meta.env): ShellConfig {
  return {
    apiBase: trimSlash(env.VITE_FIELD_API || "http://localhost:8080"),
    // 가짜 API 는 개발 서버·테스트 빌드에서만 켤 수 있다.
    fake: env.VITE_FIELD_FAKE === "1" && env.PROD !== true,
    campusOrigins: (env.VITE_CAMPUS_ORIGINS ?? "")
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean),
    campusUrl: env.VITE_CAMPUS_URL ? env.VITE_CAMPUS_URL : null,
    benchOrigin: originOf(env.VITE_BENCH_URL),
  };
}
